<template>
  <div class="divider">
    <hr class="divider--line">
    <p class="flex flex-vertical-center divider--text"><slot></slot></p>
  </div>
</template>

<script>
export default {
  name: "AppDivider",
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.divider {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  &--text {
    position: relative;
    z-index: 2;
    padding: 0 10px;
    background-color: $white;
    color: $text-muted;
    font-size: 0.75rem;
  }

  &--line {
    position: absolute;
    top: 50%;
    right: 0;
    left: 0;
    margin: 0;
  }
}
</style>
